// const API_BASE_URL="http://localhost:4000";
const API_BASE_URL="https://terminal.chipdesignonline.com";

export default API_BASE_URL;